import React, { useState, useEffect, useRef } from "react"
import algoliasearch from "algoliasearch/lite"
import { isTablet, isMobile } from "react-device-detect"
import { Col, Container, Row } from "react-bootstrap"
import $ from "jquery"
import Header from "../components/Header/Header"
import Footer from "../components/Footer/Footer"
import markerImageSrc from "../images/map-marker.svg"
import NoImage from "../images/douglas-no-image.png"
import FilterBlock from "../components/SearchResult/FilterBlock/FilterBlockNewHomes"
import SearchList from "../components/SearchResult/SearchList/SearchListNewHomes"
import "../components/SearchResult/SearchResult.scss"
import { NEW_HOMES_SEARCH_PAGE_URL } from "../components/common/site/constants"
import classNames from "classnames"
import { useLocation } from "@reach/router"
import "../components/map/osmap.scss"
import * as L from "leaflet"
import { GestureHandling } from "leaflet-gesture-handling"
import "leaflet/dist/leaflet.css"
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css"
import "leaflet.markercluster"

const client = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
)
const index_name = process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENT_INDEX_NAME

const CustomInfiniteHits = SearchList

// No Results
const NoStats = ({ nbHits, type }) => {
  return (
    <>
      {nbHits === 0 && (
        <Container>
          <Row>
            <Col lg={12} className="text-center no-properties-text mb-5">
              <h4>
                Unfortunately, we do not currently have any properties that
                match your search criteria.
              </h4>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "")
                  localStorage.setItem("searchValueFull", "")
                  localStorage.setItem("searchValueFullName", "")
                }}
                href={NEW_HOMES_SEARCH_PAGE_URL.alias}
                className="reset-link"
              >
                Reset the search
              </a>
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

const CustomNoStats = NoStats
// No Results


//map section
class GeoSearch extends React.Component {
  isUserInteraction = false
  markers = []
  autopan = false

  componentDidMount() {
    if (typeof window !== "undefined") {
      L.Control.include({
        _refocusOnMap: L.Util.falseFn, // Do nothing. when click zoom icon avoid map element focus
      })
      if (isTablet || isMobile) {
        this.instance = new L.map(this.el, { gestureHandling: true, zoom: 21 })
      } else {
        this.instance = new L.map(this.el, { gestureHandling: false, zoom: 21 })
      }

      new L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
        {
          attribution:
            '&copy; <a class="mapcopyright" href="http://osm.org/copyright" target="_blank">OpenStreetMap</a> contributors',
        }
      ).addTo(this.instance)

      window.addEventListener("resize", this.instance.invalidateSize())

      this.instance.on("autopanstart", e => {
        this.autopan = true
      })

      this.instance.on("moveend", () => {
        if (this.autopan == false) {
          if (this.isUserInteraction) {
            const ne = this.instance.getBounds().getNorthEast()
            const sw = this.instance.getBounds().getSouthWest()
            if (ne.lat != sw.lat && ne.lng != sw.lng && ne.lng < 180) {
              const bbox = `${ne.lat},${ne.lng},${sw.lat},${sw.lng}`
              this.props.changeStateAndUrl({
                insideBoundingBox: [bbox],
                page: 0,
              })
            }
          }
        }
        this.autopan = false
      })
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.instance.invalidateSize())
    }
  }
  getButtonRestElem = () => {
    return this.buttonrest
  }
  componentDidUpdate(prevProps) {
    if (prevProps.enablecluster !== this.props.enablecluster) {
      window.removeEventListener("resize", this.instance.invalidateSize())
    }
    if (prevProps.enablecluster == "") {
      window.removeEventListener("resize", this.instance.invalidateSize())
    }

    const { hits, position } = this.props
    // if (hits.length > 0) {
    //   localStorage.setItem("algoliaResult", JSON.stringify(hits))
    // }
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.instance.invalidateSize())
    }
    this.markers.forEach(marker => marker.remove())
    if (typeof window !== "undefined") {
      if (this.props?.enablecluster == "true") {
        var markersCluster = new L.markerClusterGroup({
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true,
        })
      }
      var myIcon = new L.icon({
        iconUrl: markerImageSrc,
        shadowUrl: "",

        iconSize: [22, 23], // size of the icon
        shadowSize: [22, 23], // size of the shadow
        popupAnchor: [-3, -6], // point from which the popup should open relative to the iconAnchor
      })
      if (this.props?.enablecluster == "false") {
        this.markers = hits.map(hit => {
          return new L.marker([hit._geoloc.lat, hit._geoloc.lng], {
            icon: myIcon,
          })
            .addTo(this.instance)
            .on("click", function () {
              var target = $("#" + hit.objectID)
              if (target.length) {
                $("html,body").animate(
                  { scrollTop: target.offset().top - 100 },
                  10
                )
                $(target).addClass("active").siblings().removeClass("active")
              }
            })
        })
      }
      if (this.props?.enablecluster == "true") {
        this.markers = hits.map(hit => {
          let _price = hit.price?.toLocaleString()
          let _html = hit.development_title
          let _title = hit.title
          var image_url = ""
          if (hit?.images1) {
            image_url = hit?.images1?.images_src[0]
          } else {
            image_url = NoImage
          }

          if (hit.min_price && hit.max_price) {
            if (hit.min_price == hit.max_price) {
              _price =
                "Price £" + hit.min_price ? hit.min_price.toLocaleString() : 0
            } else {
              _price =
                hit.price_prefix + "£" + hit.min_price
                  ? hit.min_price.toLocaleString()
                  : 0 + "-" + "£" + hit.max_price
                  ? hit.max_price.toLocaleString()
                  : 0
            }
          }

          var url = "/new-home-for-sale/" + hit.slug + "-" + hit.objectID
          return markersCluster.addLayer(
            new L.marker([hit._geoloc.lat, hit._geoloc.lng], { icon: myIcon })
              .bindPopup(
                '<div style="width: 250px;margin:-14px -25px -14px -21px;"><a href=' +
                  process.env.GATSBY_SITE_URL +
                  url +
                  " ><img src=" +
                  image_url +
                  ' style="width: 100%;height: 200px;object-fit: cover;" /></a><div style="padding: 20px;width:100%;"><p style="font-size:16px;color: #034051;padding-top:0px;font-family:GothamBook;margin-top: 10px;margin-bottom: 10px;">' +
                  _html +
                  '</p><p style="font-family:GothamBook;font-size: 16px;color: #005670;margin-top: 0;margin-bottom: 15px;font-weight: 600;">£' +
                  _price +
                  '</p><a style="font-family:GothamBook;text-decoration:underline;color: #034051;" target="_parent" href=' +
                  process.env.GATSBY_SITE_URL +
                  url +
                  " >View Property Details</a></div></div>"
              )
              .openPopup()
          )
        })
      }
      if (this.props?.enablecluster == "true") {
        markersCluster.addTo(this.instance)
      }

      this.isUserInteraction = false
      const { insideBoundingBox, enablecluster, currentArea } = this.props;

      if (!insideBoundingBox && this.markers.length ) {
        const newBounds = L.featureGroup(this.markers).getBounds();

        if (!this.lastBounds || !this.lastBounds.equals(newBounds) || prevProps.enablecluster !== this.props.enablecluster) {

          this.instance.fitBounds(newBounds, {
            animate: enablecluster === "true",
          });

          this.lastBounds = newBounds;
        }
      } else if (!insideBoundingBox) {
        this.instance.panTo(
          position ||
          (currentArea && currentArea.includes(",") && {
            lat: Number(currentArea.split(",")[0]) || 51.1950576,
            lng: Number(currentArea.split(",")[1]) || 0.1822206,
          }) ||
          (this.lastBounds && this.lastBounds.getCenter()) ||
          { lat: 51.1950576, lng: 0.1822206 }
        );
     }
    }
    this.isUserInteraction = false
    this.instance.on("drag", e => {
      this.isUserInteraction = true
      this.props.mapdraggedbyuser(true)
    })

    if (this.props?.enablecluster == "true") {
      this.instance.on("resize", e => {
        if (prevProps.enablecluster == this.props.enablecluster) {
          this.props.changeStateAndUrl({
            insideBoundingBox: [],
            page: 0,
          })
          this.props.mapdraggedbyuser(false)
        }
      })
      this.instance.on("mousedown mouseup touchend touchstart zoomanim", e => {
        if (prevProps.enablecluster == this.props.enablecluster) {
          this.props.mapdraggedbyuser(true)
        }
      })
    } else {
      this.instance.on("mousedown mouseup touchend touchstart zoomanim", e => {
        this.isUserInteraction = true
        this.props.mapdraggedbyuser(true)
      })
    }
  }

  render() {
    const hasBBox = this.props.insideBoundingBox?.length > 0
    return (
      <div
        id="location-map"
        className={`${
          this.props?.enablecluster == "true" ? "location-map" : ""
        }`}
      >
        <div ref={c => (this.el = c)} />
        {hasBBox && (
          <button
            id="mymapclearBtn"
            ref={this.props.buttonrest}
            className="maprefinebutton"
            onClick={() =>
              this.props.changeStateAndUrl({
                insideBoundingBox: [],
                page: 0,
              })
            }
          >
            Clear map refinement
          </button>
        )}
      </div>
    )
  }
}

const CustomGeoSearch = GeoSearch

// map section ends here

const SearchTemplate = props => {
  const [sold, setIncludeSold] = React.useState(false)
  const [scroll, setScroll] = useState(false)
  const [underOffer, setIncludeUnderOffer] = React.useState(false)
  const [scrollToTopBtn, setScrollToTop] = useState(false)
  const buttonrest = React.createRef()
  const [mapdragbyuser, setMapdragbyuser] = React.useState(false)

  const [results, setResults] = useState([])
  const [nbHits, setNbHits] = useState(0)
  const [renderComp, setRenderComp] = useState(false)

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 1)
      if (window.pageYOffset > 500) {
        setScrollToTop(true)
      } else {
        setScrollToTop(false)
      }
    })

    // iphone zoom issue when type a text in input field
    $("head").append(
      '<meta name="viewport" content="width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0">'
    )
    $("body").addClass("search-template")
    // iphone zoom issue when type a textin input field
  }, [])

  const includeSold = value => {
    setIncludeSold(value)
  }

  const mapdraggedbyuser = value => {
    setMapdragbyuser(value)
  }

  const includeUnderOffer = value => {
    setIncludeUnderOffer(value)
  }
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smoothly scrolling
    })
  }

  useEffect(() => {
    if (!props.isReady) return

    const fetchData = async () => {
      try {
        const index = client.initIndex(props.sortBy || index_name)

        const filters = []

        if (props.building) {
          filters.push(`building:"${props.building}"`)
        }
        if (props.min > 0) {
          filters.push(`min_price >= ${props.min}`)
        }
        if (props.max > 0) {
          filters.push(`min_price <= ${props.max}`)
        }

        if (props.bedrooms !== undefined && props.bedrooms !== "") {
          const bedroomsNum = Number(props.bedrooms);
          if (bedroomsNum === 0) {
            filters.push(`bedrooms <= 0`)
          } else if (!isNaN(bedroomsNum)) {
            filters.push(`bedrooms >= ${bedroomsNum}`)
          }
        }

        const searchParams = {
          filters: filters.join(" AND "),
          ...props.algoliaConfig,
          page: props.mapView ? 0 : (props.page ?? 1) - 1,
          aroundLatLng: props.aroundLatLng,
          aroundRadius: props.aroundRadius,
          getRankingInfo: props.getRankingInfo,
          hitsPerPage: props.mapView ? 200 : 60,
        }

        if (props.insideBoundingBox?.length) {
          searchParams.insideBoundingBox = [
            props.insideBoundingBox[0].split(",").map(Number),
          ]
        }

        const { hits, nbHits } = await index.search(
          props.aroundLatLng ? "" : (props?.query && props.query.trim()) || "",
          searchParams
        )
        localStorage.setItem('algoliaResult', JSON.stringify(hits));
        setResults(hits)
        setNbHits(nbHits)
      } catch (err) {
        console.error("Algolia search failed", err)
      } finally {
        setRenderComp(true)
      }
    }

    fetchData()
  }, [
    props.query,
    props.aroundLatLng,
    props.aroundRadius,
    props.getRankingInfo,
    props.algoliaConfig,
    props.searchType,
    props.mapView,
    props.page,
    props.sortBy,
    props.isReady,
    props.insideBoundingBox,
    props.building,
    props.min,
    props.max,
    props.bedrooms,
    props.property_promotions,
  ])

  //let realUser = true
  // realUser = false // meaningless, we dont have any fallback here for the bots

  return (
    <div
      className={`${
        scroll
          ? "wrapper search-result-page scroll new-home-search-result"
          : "wrapper search-result-page new-home-search-result"
      }`}
    >
      <Header type="results" />
      <FilterBlock
        {...props}
        searchDisable={false}
        buttonrest={buttonrest}
        includeSold={includeSold}
        mapdraggedbyuser={mapdraggedbyuser}
        includeUnderOffer={includeUnderOffer}
        mapView={props.mapView}
        searchType={"sales"}
        query={props.query}
        index_name={index_name}
        search_area={props.search_area}
        h1={props.h1}
        desc={props.desc}
        off_plan={false}
        sales={true}
        changeRadius={props.changeRadius}
      />
      <div
        className={`search-result-block mobile-view-results-page ${
          props.mapView ? " d-block" : ""
        }`}
      >
        {props.mapView ? (
          <button
            className="exit-button"
            onClick={() => {
              const newProps = { ...props, insideBoundingBox: [], page: 0 }
              props.changeToListUrl()
              props.changeStateAndUrl(newProps)
              sessionStorage.setItem("MainView", "List")
              localStorage.removeItem("map-hits")
            }}
           >
            <i className="arrow-left"></i>Exit Map
          </button>
        ) : (
          ""
        )}
        {renderComp && (
          <div className={`search-list-block ${props.mapView ? "d-none" : ""}`}>
            <CustomInfiniteHits
              hits={results}
              nbHits={nbHits}
              nbPages={Math.ceil(nbHits / 60)}
              {...props}
              mapdragbyuser={mapdragbyuser}
              off_plan={false}
              index_name={index_name}
              search_area={props.search_area}
              sortByIndex={
                props.location.pathname.includes("most-recent")
                  ? index_name + "_most_recent"
                  : index_name
              }
            />
            <CustomNoStats
              val={
                props.location.pathname.includes("most-recent")
                  ? index_name + "_most_recent"
                  : index_name
              }
              type={props.search_type}
              nbHits={nbHits}
            />
         </div>
        )}

        <div
          className={`${
            props.mapView ? "map-box grid-view" : "map-box map-box-listview"
          } ${1 == 1 ? "mobile-loc-map" : ""}`}
          id="res-div-two"
         >
          <div id="map-holder" className={classNames("map")}>
            <CustomGeoSearch
               buttonrest={buttonrest}
              mapdraggedbyuser={mapdraggedbyuser}
              enablecluster={props.mapView ? "true" : "false"}
              hits={results}
              currentArea={props?.aroundLatLng}
              changeStateAndUrl={props.changeStateAndUrl}
             />
          </div>
        </div>
      </div>
       {scrollToTopBtn && (
        <button onClick={scrollToTop} className="back-to-top">
          <i className="icon-up"></i>
        </button>
      )}
      <Footer
        searchtype="newhomesales"
        search="searchresults"
        searchPtype={props.property_type}
        popularSearch="propertyresults"
        searchBedroomfield={props.bedrooms}
        Searcharea={props.search_area}
      />
    </div>
  )
}

export default SearchTemplate
